export const nationalitys = [
  "Brasileira",
  "Afegã",
  "Sul-africana",
  "Albanesa",
  "Alemã",
  "Andorrana",
  "Angolana",
  "Antiguana",
  "Saudita",
  "Argelina",
  "Argentina",
  "Armênia",
  "Australiana",
  "Austríaca",
  "Azerbaijana",
  "Bahamaense",
  "Bangladeshiana",
  "Barbadiana",
  "Bahrainiana",
  "Belga",
  "Belizenha",
  "Beninense",
  "Bermudense",
  "Boliviana",
  "Bósnia",
  "Botsuanense",
  "Brasileira",
  "Britânica",
  "Bruneiana",
  "Búlgara",
  "Burquinense",
  "Burundiana",
  "Butanesa",
  "Cabo-verdiana",
  "Camaronesa",
  "Canadense",
  "Chadiana",
  "Chilena",
  "Chinesa",
  "Cingapuriana",
  "Colombiana",
  "Comorense",
  "Congolesa",
  "Norte-coreana",
  "Sul-coreana",
  "Costa-riquenha",
  "Croata",
  "Cubana",
  "Dinamarquesa",
  "Djiboutiana",
  "Dominicana",
  "Egípcia",
  "Salvadorenha",
  "Emiradense",
  "Equatoriana",
  "Eritreia",
  "Eslovaca",
  "Eslovena",
  "Espanhola",
  "Estoniana",
  "Etíope",
  "Fijiana",
  "Filipina",
  "Finlandesa",
  "Francesa",
  "Gabonesa",
  "Gambiana",
  "Ganesa",
  "Georgiana",
  "Grega",
  "Grenadiana",
  "Guatemalteca",
  "Guianense",
  "Guineense",
  "Haitiana",
  "Holandesa",
  "Hondurenha",
  "Húngara",
  "Iemenita",
  "Indiana",
  "Indonésia",
  "Iraniana",
  "Iraquiana",
  "Irlandesa",
  "Islandesa",
  "Israelense",
  "Italiana",
  "Jamaicana",
  "Japonesa",
  "Jordaniana",
  "Cazaque",
  "Queniana",
  "Kuwaitiana",
  "Laosiana",
  "Letã",
  "Libanesa",
  "Liberiana",
  "Líbia",
  "Liechtensteiniana",
  "Lituana",
  "Luxemburguesa",
  "Macedônia",
  "Madagascarense",
  "Malaia",
  "Malauiana",
  "Maldívia",
  "Mali",
  "Maltesa",
  "Marfinense",
  "Marroquina",
  "Mauritânia",
  "Maurícia",
  "Mexicana",
  "Micronésia",
  "Moçambicana",
  "Moldávia",
  "Mongol",
  "Montenegrina",
  "Namíbia",
  "Nauruana",
  "Nepalesa",
  "Nicaraguense",
  "Nigeriana",
  "Nigerina",
  "Norueguesa",
  "Neozelandesa",
  "Omã",
  "Panamenha",
  "Paquistanesa",
  "Paraguaia",
  "Peruana",
  "Polonesa",
  "Portuguesa",
  "Qatariana",
  "Romena",
  "Russa",
  "Ruandesa",
  "São-cristovense",
  "Samoana",
  "Santalucense",
  "São-marinense",
  "Santomense",
  "Saudita",
  "Senegalesa",
  "Sérvia",
  "Seichelense",
  "Serra-leonesa",
  "Singapuriana",
  "Síria",
  "Somali",
  "Sri-lanquesa",
  "Sul-africana",
  "Sueca",
  "Suíça",
  "Surinamesa",
  "Suazilandesa",
  "Tadjiquista",
  "Tanzaniana",
  "Tailandesa",
  "Timorense",
  "Togolesa",
  "Tonganesa",
  "Trinitina",
  "Tunisiana",
  "Turca",
  "Turcomena",
  "Tuvaluana",
  "Ucraniana",
  "Ugandense",
  "Uruguaia",
  "Uzbeque",
  "Vanuatuana",
  "Venezuelana",
  "Vietname",
  "Zambiana",
  "Zimbabuana",
];
